module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#strategy",
      toString: function () {
        return this.url;
      }
    }